// extracted by mini-css-extract-plugin
module.exports = {"linkInput":"TeamInvitationItem_linkInput_1mIR0"};